export default "__VITE_PUBLIC_ASSET__f4c63047__"